'use client'

import { useAgentAuthDetails, useUserAuthDetails } from '@repo/services'
import * as Sentry from '@sentry/nextjs'
import { useEffect, useRef } from 'react'
import { globalConfig } from '../../utils/global-config'

const isProduction = globalConfig.isProduction

export const SentryProvider = ({ children }: { children: React.ReactNode }) => {
  // Track if user was previously set to distinguish between initial empty state and logout
  const wasUserSetRef = useRef(false)
  const { data: { data: authDetails } = {} } = globalConfig.isAgents
    ? useAgentAuthDetails()
    : useUserAuthDetails()
  const userId = authDetails?.id

  useEffect(() => {
    if (isProduction) {
      // Check if user has valid data (not just empty object)
      const hasValidUser = userId && Object.keys(authDetails).length > 0

      if (hasValidUser && userId) {
        // Set user context for Sentry - this will be automatically attached to all logs and errors
        // User information will appear in Sentry dashboard as: userId, user.email, user.name
        Sentry.setUser({
          id: userId.toString(),
          email: authDetails.email,
          username: authDetails.phone,
          uuid: authDetails.uuid,
        })
        wasUserSetRef.current = true
      } else {
        // Only clear user if we're sure user is logged out (not just initial empty state)
        // Don't set null for initial empty state to avoid sending empty user
        if (wasUserSetRef.current) {
          // User was previously set, now clear it (user logged out)
          Sentry.setUser(null)
          wasUserSetRef.current = false
        }
        // If no previous user, don't set anything (avoid sending empty user)
      }
    }
  }, [authDetails])

  return <>{children}</>
}
